module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("XIARj"))).then(() => parcelRequire('1Nwmy'));